define('SageDotCom/DataLayer/Events/Forms/formSubmitSuccess',['jquery', 'SageDotCom/DataLayer/Events/eventBase'], function ($, EventBase) {
    function FormSubmitSuccessEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = 'form_submit_success'; // overwrite name
    }

    FormSubmitSuccessEvent.prototype = Object.create(EventBase.prototype);

    FormSubmitSuccessEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope) {
        var eventData = {
            "event_name": this.getName(), //event name
            "event_non-int": "0", //non interaction point
            "event_category": "contact", //top line category
            "event_action": "form submit", //specific action
            "release_date": "17th October 2024"
        }

        var eventDataGA4 = {
            "event": this.getName(), //event name
            "triggered_by": "sitecore"
        }
        if (scope) {

            var location = this.getLocation(scope);
            var level5 = $(scope).closest('form').find('[data-sc-field-name="Level5"]');
            var modal = $(scope).closest(".modal");

            var progressBar;
            if ($(scope).closest("form").find(".product-trial-form").length > 0) {
                progressBar = $(".product-trial-header .progress-bar-holder");
            }
            else if ($(scope).closest("form").find(".privacy-rights-request-form").length > 0) {
                progressBar = $(".score-style-box.privacy-rights-request .progress-bar-holder");
            }
            else {
                progressBar = $(scope).closest("form").siblings(".progress-bar-holder");
            }

            eventData = $.extend(eventData,
                {
                    'event_label': "successful",
                    'event_name_level_1': this.getId(scope),
                    'event_name_level_2': $(scope).closest('form').attr('id'),
                    'event_name_level_3': "(not set)",
                    'event_name_level_4': location,
                    'event_name_level_5': level5.length > 0 ? level5[0].defaultValue : "(not set)"
                });
            eventDataGA4 = $.extend(eventDataGA4, {
                "gate_content_name": level5.length > 0 ? level5[0].defaultValue : "(not set)",
                "form_step": progressBar.length > 0 ? parseInt(progressBar.find("li .progress-bar-current .progress-bar-index")[0].textContent) : 1,
                "total_steps": progressBar.length > 0 ? progressBar.find("li").length : 1,
                "form_type": progressBar.length > 0 ? "multistep" : "normal",
                "form_id": $(scope).closest('form').attr('id'),
                "display_method": modal.length > 0 ? "modal" : "inline"
            });
        }
        eventData = $.extend(eventData, eventDataGA4);
        return eventData;
    }

    return new FormSubmitSuccessEvent();   
});
